import React from 'react';

import Image from 'next/image';
import { useRouter } from 'next/router';
import clsx from 'clsx';

import { routes } from '@routes';

import { link } from '@utils/link';
import { messageIdConcat } from '@utils/message-id-concat';
import { sendGAEvent } from '@utils/google-analytics';

import { Button } from '@molecules/button';
import { Icon, Text } from '@atoms';

import classes from './estimate-landing-page-a.module.scss';

const m = messageIdConcat('estimate_landing_page');

export const EstimateLandingPageA = () => {
  const router = useRouter();

  return (
    <div className={classes.wrapper}>
      {/* section 1 */}
      <section className={clsx(classes.section1)}>
        <div className={classes.reasContainer}>
          <div className={classes.container}>
            <div className={classes.textWrapper}>
              <div className={classes.arrow}>
                <Image
                  src={require('@public/static/img/estimate-landing-page/arrow_bottom_left.svg')}
                  layout="fill"
                  unoptimized
                />
              </div>
              <Text
                fontWeight={700}
                fontSize={32}
                fontFamily="poppins"
                md={{ fontSize: 40 }}
                message={{ id: m('section_one.title') }}
                margin={[40, 0, 32, 0]}
                lineHeight="1.5"
              />
              <div className={classes.infoWrapper}>
                <div className={classes.icon}>
                  <Image
                    src={require('@public/static/img/estimate-landing-page/check-green-circle2.svg')}
                    layout="fill"
                    unoptimized
                  />
                </div>
                <Text
                  fontWeight={400}
                  fontSize={18}
                  message={{ id: m('section_one.info_1') }}
                  margin={[0]}
                  lineHeight="1.5"
                />
              </div>
              <div className={classes.infoWrapper}>
                <div className={classes.icon}>
                  <Image
                    src={require('@public/static/img/estimate-landing-page/check-green-circle2.svg')}
                    layout="fill"
                    unoptimized
                  />
                </div>
                <Text
                  fontWeight={400}
                  fontSize={18}
                  message={{ id: m('section_one.info_2') }}
                  margin={[0]}
                  lineHeight="1.5"
                />
              </div>
              <div className={classes.infoWrapper}>
                <div className={classes.icon}>
                  <Image
                    src={require('@public/static/img/estimate-landing-page/check-green-circle2.svg')}
                    layout="fill"
                    unoptimized
                  />
                </div>
                <Text
                  fontWeight={400}
                  fontSize={18}
                  message={{ id: m('section_one.info_3') }}
                  margin={[0]}
                  lineHeight="1.5"
                />
              </div>
              <Button
                message={{ id: m('section_one.cta.want_estimate') }}
                className={classes.btn}
                link={link(
                  routes.estimateSurvey,
                  {},
                  { ...router.query, et: 'Odhad ceny' },
                )}
                onClick={() => {
                  sendGAEvent(
                    'Button',
                    'click',
                    'Spocitat_odhad_zdarma_Hero_LP_Odhad',
                  );
                }}
              />
            </div>
            <div className={classes.imageWrapper}>
              <div className={classes.estimateImage}>
                <Image
                  src={require('@public/static/img/estimate-landing-page/estimate2.png')}
                  width={297}
                  height={179}
                  unoptimized
                />
              </div>
              <div className={classes.womanImage}>
                <Image
                  src={require('@public/static/img/estimate-landing-page/woman2.png')}
                  width={370}
                  height={438}
                  unoptimized
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* section 2 */}
      <section className={classes.section2}>
        <div className={classes.reasContainer}>
          <Text
            color={'big_stone'}
            fontWeight={600}
            fontSize={20}
            fontFamily="poppins"
            message={{ id: m('section_two.title') }}
            margin={[40, 'auto', 25]}
            md={{ margin: [40, 'auto', 32], maxWidth: 355 }}
            textAlign="center"
            lineHeight="1.5"
            maxWidth={280}
          />
          <div className={classes.ratingWrapper}>
            <div className={classes.starsWrapper}>
              <Icon icon="star" />
              <Icon icon="star" />
              <Icon icon="star" />
              <Icon icon="star" />
              <Icon icon="star-half" />
            </div>
            <div className={classes.logoWrapper}>
              <Image
                src={require('@public/static/img/estimate-landing-page/google.svg')}
                width={75}
                height={25}
                unoptimized
              />
              <Image
                src={require('@public/static/img/estimate-landing-page/seznam.svg')}
                width={98}
                height={20}
                unoptimized
              />
            </div>
            <Text
              color={'big_stone'}
              fontWeight={400}
              fontSize={14}
              message={{ id: m('section_two.review') }}
              margin={[0]}
              lineHeight="1.5"
              textAlign="center"
            />
          </div>
        </div>
      </section>

      {/* section 3 */}
      <section className={classes.section3}>
        <div className={classes.reasContainer}>
          <Text
            color={'fiord'}
            fontWeight={400}
            fontSize={18}
            message={{ id: m('section_three.title') }}
            margin={[0, 0, 24, 0]}
            md={{ margin: [0, 0, 48, 0] }}
            textAlign="center"
            lineHeight="1.5"
          />
          <div className={classes.contentWrapper}>
            <div className={classes.item}>
              <Text
                color={'big_stone'}
                fontWeight={600}
                fontSize={20}
                fontFamily="poppins"
                message={{ id: m('section_three.item.title') }}
                margin={[0, 0, 8, 0]}
                lineHeight="1.5"
              />
              <Text
                color={'fiord'}
                fontWeight={400}
                fontSize={16}
                message={{ id: m('section_three.item.content') }}
                margin={[0]}
                lineHeight="1.5"
              />
            </div>
            <div className={classes.item}>
              <Text
                color={'big_stone'}
                fontWeight={600}
                fontSize={20}
                fontFamily="poppins"
                message={{ id: m('section_three.item_2.title') }}
                margin={[0, 0, 8, 0]}
                lineHeight="1.5"
              />
              <Text
                color={'fiord'}
                fontWeight={400}
                fontSize={16}
                message={{ id: m('section_three.item_2.content') }}
                margin={[0]}
                lineHeight="1.5"
              />
            </div>
            <div className={classes.item}>
              <Text
                color={'big_stone'}
                fontWeight={600}
                fontSize={20}
                fontFamily="poppins"
                message={{ id: m('section_three.item_3.title') }}
                margin={[0, 0, 8, 0]}
                lineHeight="1.5"
              />
              <Text
                color={'fiord'}
                fontWeight={400}
                fontSize={16}
                message={{ id: m('section_three.item_3.content') }}
                margin={[0]}
                lineHeight="1.5"
              />
            </div>
            <div className={classes.item}>
              <Text
                color={'big_stone'}
                fontWeight={600}
                fontSize={20}
                fontFamily="poppins"
                message={{ id: m('section_three.item_4.title') }}
                margin={[0, 0, 8, 0]}
                lineHeight="1.5"
              />
              <Text
                color={'fiord'}
                fontWeight={400}
                fontSize={16}
                message={{ id: m('section_three.item_4.content') }}
                margin={[0]}
                lineHeight="1.5"
              />
            </div>
          </div>
        </div>
      </section>

      {/* section 4 */}
      <div className={classes.writeAboutUs}>
        <div className={classes.text}>
          <Text
            color={'dummy_gray'}
            fontWeight={400}
            fontSize={14}
            fontFamily="poppins"
            sm={{ fontSize: 18 }}
            message={{ id: m('section_four.write_about_us.title') }}
            margin={['auto', 0]}
            lineHeight="1.5"
          />
        </div>
        <Image
          src={require('@public/static/img/estimate-landing-page/idnes.svg')}
          width={81}
          height={26}
          unoptimized
        />
        <Image
          src={require('@public/static/img/estimate-landing-page/hospodarske-noviny.svg')}
          width={252}
          height={23}
          unoptimized
        />
        <Image
          src={require('@public/static/img/estimate-landing-page/czechcrunch.svg')}
          width={183}
          height={21}
          unoptimized
        />
        <Image
          src={require('@public/static/img/estimate-landing-page/echo24.svg')}
          width={147}
          height={35}
          unoptimized
        />
        <Image
          src={require('@public/static/img/estimate-landing-page/e15.png')}
          width={88}
          height={25}
          objectFit="contain"
          unoptimized
        />
      </div>

      {/* section 5 */}
      <section className={classes.section5}>
        <div className={classes.reasContainer}>
          <Text
            color={'fiord'}
            fontWeight={400}
            fontSize={18}
            lg={{ fontSize: 32, color: 'big_stone', fontWeight: 600 }}
            message={{ id: m('section_five.title') }}
            textAlign="center"
            margin={[0]}
            lineHeight="1.5"
          />
          <div className={classes.contentWrapper}>
            <div className={classes.item}>
              <div className={classes.step}>
                <b>1</b>
              </div>
              <Text
                color={'big_stone'}
                fontWeight={600}
                fontSize={20}
                fontFamily="poppins"
                lg={{ textAlign: 'center' }}
                message={{ id: m('section_five.item.title') }}
                margin={[0]}
                maxWidth={190}
                lineHeight="1.5"
              />
            </div>
            <div className={classes.arrow}>
              <Image
                src={require('@public/static/img/estimate-landing-page/arrow-down.svg')}
                width={30}
                height={22}
                unoptimized
              />
            </div>
            <div className={classes.item}>
              <div className={classes.step}>
                <b>2</b>
              </div>
              <Text
                color={'big_stone'}
                fontWeight={600}
                fontSize={20}
                fontFamily="poppins"
                lg={{ textAlign: 'center' }}
                message={{ id: m('section_five.item_2.title') }}
                margin={[0]}
                maxWidth={190}
                lineHeight="1.5"
              />
            </div>
            <div className={classes.arrow}>
              <Image
                src={require('@public/static/img/estimate-landing-page/arrow-down.svg')}
                width={30}
                height={22}
                unoptimized
              />
            </div>
            <div className={classes.item}>
              <div className={classes.step}>
                <b>3</b>
              </div>
              <Text
                color={'big_stone'}
                fontWeight={600}
                fontSize={20}
                fontFamily="poppins"
                lg={{ textAlign: 'center' }}
                message={{ id: m('section_five.item_3.title') }}
                margin={[0]}
                maxWidth={190}
                lineHeight="1.5"
              />
            </div>
          </div>
          <div className={classes.btnWrapper}>
            <Button
              message={{ id: m('section_five.cta.want_estimate') }}
              className={classes.btn}
              link={link(
                routes.estimateSurvey,
                {},
                { ...router.query, et: 'Odhad ceny' },
              )}
              onClick={() => {
                sendGAEvent(
                  'Button',
                  'click',
                  'Spocitat_odhad_zdarma_Postup_LP_Odhad',
                );
              }}
            />
          </div>
        </div>
      </section>

      {/* section 6 */}
      <section className={classes.section6}>
        <div className={classes.reasContainer}>
          <Text
            color={'big_stone'}
            fontWeight={600}
            fontSize={24}
            fontFamily="poppins"
            textAlign="center"
            lg={{ fontSize: 32 }}
            message={{ id: m('section_six.title') }}
            margin={[0]}
            lineHeight="1.5"
          />
          <div className={classes.contentWrapper}>
            <div className={classes.col}>
              <div className={classes.item}>
                <div className={classes.profileWrapper}>
                  <Image
                    src={require('@public/static/img/atlas/unknownSellerAvatar.svg')}
                    width={32}
                    height={32}
                    unoptimized
                  />
                  <Text
                    color={'big_stone'}
                    fontWeight={600}
                    fontSize={14}
                    message={{ id: m('section_six.item.fullname') }}
                    margin={[0]}
                    lineHeight="1.5"
                  />
                </div>
                <div className={classes.dateWrapper}>
                  <div className={classes.ratingWrapper}>
                    <Icon icon="star" />
                    <Icon icon="star" />
                    <Icon icon="star" />
                    <Icon icon="star" />
                    <Icon icon="star" />
                  </div>
                  <Text
                    color={'slate_gray'}
                    fontWeight={400}
                    fontSize={14}
                    message={{ id: m('section_six.item.date') }}
                    margin={[0]}
                    lineHeight="1.5"
                  />
                </div>
                <Text
                  color={'big_stone'}
                  fontWeight={400}
                  fontSize={14}
                  message={{ id: m('section_six.item.message') }}
                  margin={[0]}
                  lineHeight="1.5"
                />
              </div>
              <div className={classes.item}>
                <div className={classes.profileWrapper}>
                  <Image
                    src={require('@public/static/img/atlas/unknownSellerAvatar.svg')}
                    width={32}
                    height={32}
                    unoptimized
                  />
                  <Text
                    color={'big_stone'}
                    fontWeight={600}
                    fontSize={14}
                    message={{ id: m('section_six.item_2.fullname') }}
                    margin={[0]}
                    lineHeight="1.5"
                  />
                </div>
                <div className={classes.dateWrapper}>
                  <div className={classes.ratingWrapper}>
                    <Icon icon="star" />
                    <Icon icon="star" />
                    <Icon icon="star" />
                    <Icon icon="star" />
                    <Icon icon="star" />
                  </div>
                  <Text
                    color={'slate_gray'}
                    fontWeight={400}
                    fontSize={14}
                    message={{ id: m('section_six.item_2.date') }}
                    margin={[0]}
                    lineHeight="1.5"
                  />
                </div>
                <Text
                  color={'big_stone'}
                  fontWeight={400}
                  fontSize={14}
                  message={{ id: m('section_six.item_2.message') }}
                  margin={[0]}
                  lineHeight="1.5"
                />
              </div>
            </div>
            <div className={classes.col}>
              <div className={classes.item}>
                <div className={classes.profileWrapper}>
                  <Image
                    src={require('@public/static/img/atlas/unknownSellerAvatar.svg')}
                    width={32}
                    height={32}
                    unoptimized
                  />
                  <Text
                    color={'big_stone'}
                    fontWeight={600}
                    fontSize={14}
                    message={{ id: m('section_six.item_3.fullname') }}
                    margin={[0]}
                    lineHeight="1.5"
                  />
                </div>
                <div className={classes.dateWrapper}>
                  <div className={classes.ratingWrapper}>
                    <Icon icon="star" />
                    <Icon icon="star" />
                    <Icon icon="star" />
                    <Icon icon="star" />
                    <Icon icon="star" />
                  </div>
                  <Text
                    color={'slate_gray'}
                    fontWeight={400}
                    fontSize={14}
                    message={{ id: m('section_six.item_3.date') }}
                    margin={[0]}
                    lineHeight="1.5"
                  />
                </div>
                <Text
                  color={'big_stone'}
                  fontWeight={400}
                  fontSize={14}
                  message={{ id: m('section_six.item_3.message') }}
                  margin={[0]}
                  lineHeight="1.5"
                />
              </div>
              <div className={classes.item}>
                <div className={classes.profileWrapper}>
                  <Image
                    src={require('@public/static/img/atlas/unknownSellerAvatar.svg')}
                    width={32}
                    height={32}
                    unoptimized
                  />
                  <Text
                    color={'big_stone'}
                    fontWeight={600}
                    fontSize={14}
                    message={{ id: m('section_six.item_4.fullname') }}
                    margin={[0]}
                    lineHeight="1.5"
                  />
                </div>
                <div className={classes.dateWrapper}>
                  <div className={classes.ratingWrapper}>
                    <Icon icon="star" />
                    <Icon icon="star" />
                    <Icon icon="star" />
                    <Icon icon="star" />
                    <Icon icon="star-half" />
                  </div>
                  <Text
                    color={'slate_gray'}
                    fontWeight={400}
                    fontSize={14}
                    message={{ id: m('section_six.item_4.date') }}
                    margin={[0]}
                    lineHeight="1.5"
                  />
                </div>
                <Text
                  color={'big_stone'}
                  fontWeight={400}
                  fontSize={14}
                  message={{ id: m('section_six.item_4.message') }}
                  margin={[0]}
                  lineHeight="1.5"
                />
              </div>
            </div>
          </div>
          <Text
            color={'fiord'}
            fontWeight={400}
            fontSize={18}
            message={{ id: m('section_six.more') }}
            margin={[0]}
            textAlign="center"
            lineHeight="1.5"
          />
        </div>
      </section>

      {/* section 7 */}
      <section className={classes.section7}>
        <div className={classes.reasContainer}>
          <div className={classes.container}>
            <div className={classes.imageWrapper}>
              <Image
                src={require('@public/static/img/estimate-landing-page/opacity-iphone.png')}
                height={549}
                width={464}
                unoptimized
              />
              <div className={classes.estimateImage}>
                <Image
                  src={require('@public/static/img/estimate-landing-page/estimate3.png')}
                  height={285}
                  width={370}
                  unoptimized
                />
              </div>
            </div>
            <div className={classes.contentWrapper}>
              <Text
                color={'big_stone'}
                fontWeight={700}
                fontSize={24}
                fontFamily="poppins"
                message={{ id: m('section_seven.title') }}
                textAlign="center"
                maxWidth={300}
                margin={[0, 0, 32, 0]}
                md={{ fontSize: 24, textAlign: 'left' }}
                lg={{ maxWidth: 550 }}
                xl={{
                  fontSize: 32,
                  textAlign: 'left',
                  margin: [0, 0, 48, 0],
                }}
                lineHeight="1.5"
              />
              <Button
                message={{
                  id: m('section_seven.cta.calc_estimate'),
                }}
                className={classes.btn}
                link={link(
                  routes.estimateSurvey,
                  {},
                  { ...router.query, et: 'Odhad ceny' },
                )}
                onClick={() => {
                  sendGAEvent(
                    'Button',
                    'click',
                    'Spocitat_odhad_zdarma_Footer_LP_Odhad',
                  );
                }}
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
